module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"NumberofEmployee":"Number of Employee","AttendanceStaff":"Attendance Staff","ProductTrends":"Product Trends","StoreStatus":"Store Status","Inhousesituation":"In house situation","Author":"Author"}}')
  delete Component.options._Ctor
}
